
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/siteindex",
      function () {
        return require("private-next-pages/siteindex.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/siteindex"])
      });
    }
  